import { HotelsAvailabilityActions } from "@b2bportal/core-hotels";
import { type FollowUpResponse, packagesApi } from "@b2bportal/packages-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PackageHotelActions } from "../slice";

const POLLING_DELAY_MS = 2000;

export const fetchPackageHotelAvailabilityMore = createAsyncThunk<
  void,
  { nextPageToken: string; searchId: string }
>("packages/fetchMoreHotels", async ({ nextPageToken, searchId }, thunkAPI) => {
  try {
    thunkAPI.dispatch(HotelsAvailabilityActions.handleFetchNextPagePending());

    const res = await packagesApi(axios).apiV0PackagesAvailabilityPost({
      nextPageToken: { value: nextPageToken },
      PackageAvailabilityRequest: "FollowUpRequest",
    });

    const nextPageResponse = res.data as FollowUpResponse;

    const nextPageLodgingResponse = nextPageResponse.product.response.value;

    thunkAPI.dispatch(
      HotelsAvailabilityActions.handleFetchNextPageFulfilled({
        ...nextPageLodgingResponse,
        searchId,
      })
    );

    if (nextPageResponse.product.nextPageToken != null) {
      const newNextPageToken = nextPageResponse.product.nextPageToken.value;

      thunkAPI.dispatch(
        PackageHotelActions.setHotelAvailabilityPackagePricing({
          packagesByLodgingId: Object.fromEntries(
            Object.entries(nextPageResponse.product.packagesByLodgingId).map(
              ([key, lodging]) => [key, lodging.packageSummary]
            )
          ),
          searchId,
        })
      );

      await new Promise((resolve) => setTimeout(resolve, POLLING_DELAY_MS));

      thunkAPI.dispatch(
        fetchPackageHotelAvailabilityMore({
          nextPageToken: newNextPageToken,
          searchId,
        })
      );
    }
  } catch (e) {
    console.error("Failed to fetch more hotels:", e);
    const errorMessage = e instanceof Error ? e.message : String(e);
    const error = { error: errorMessage };
    thunkAPI.dispatch(
      HotelsAvailabilityActions.handleFetchNextPageRejected(error)
    );
    return thunkAPI.rejectWithValue(error);
  }
});
